import React from "react";
import PropTypes from "prop-types";
import { Select } from "chakra-react-select";
import { defaultOptionsStyle } from "../styled/details/stylesSelect";

export default function TldrChakraSelect(props) {
  return (
    <Select
      {...props}
      options={props.options}
      onChange={props.onChange}
      chakraStyles={
        props.chakraStyles ? props.chakraStyles : defaultOptionsStyle
      }
      value={props.value}
    />
  );
}

TldrChakraSelect.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
